import {Component, ViewEncapsulation} from '@angular/core';
import {FidjiAppDeviceSettingsService, FidjiNetworkService} from '@immanens-com/fidji-api-module';
import {Router, RouterOutlet} from '@angular/router';
import {routeAnimation} from './shared/animations/router.animations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [ routeAnimation ],
  encapsulation: ViewEncapsulation.None
})
export class AppComponent {

  public appIsReady = false;

  private lastVisitedRoute: string;

  constructor(
    private settings: FidjiAppDeviceSettingsService,
    private networkService: FidjiNetworkService,
    private router: Router
  ) {
    this.subscribeToNetworkActivity();
    this.subscribeToTokenIsSetChange();
  }

  /**
   * Need this function on app init cause the app is blocked
   * since the token is correctly set.
   * A spinner is shown over the view for mention to user we don't have a token
   */
  subscribeToTokenIsSetChange() {
    this.settings.appSettingsChange.subscribe( settings => {
      if (!this.appIsReady) { this.appIsReady = settings != null; }
    });
  }

  /**
   * Subscribe to network isOnline observable
   * The connection is checked in certain page transition with Connection guard
   * If the network turn down, we just navigate to no-connection component
   * See connection.guard.ts for more
   */
  subscribeToNetworkActivity() {
    this.networkService.isOnlineChange.subscribe((isOnline) => {
      if (!isOnline && !new RegExp('no-connection').test(this.router.url) && !new RegExp('library').test(this.router.url)) {
        // if not online and not on no-connection or library, go to no-connection
        this.lastVisitedRoute = this.router.url;
        this.router.navigate(['no-connection']);
      } else if (isOnline && new RegExp('no-connection').test(this.router.url)) {
        // if is online and on no-connection, go to last visited
        this.router.navigateByUrl(this.lastVisitedRoute);
      }
    });
  }

  public getDepth(outlet: RouterOutlet) {
    //window.scrollTo(0, 0);
    return outlet.activatedRouteData['depth'];
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts